import * as v from 'valibot';
import {
	Field,
	RadioField,
	TermsAndConditionsCheckboxField,
} from '../ContactForm.types';
import { useMemo } from 'react';
import { typeGuard } from 'tsafe';

export const getValidationSchema = (field: Field) => {
	const { type, required } = field;

	let NonEmptyValidationSchema:
		| v.NonEmptyAction<string, string | undefined>
		| v.AnySchema = v.any();

	if (required === true) {
		if (
			typeGuard<TermsAndConditionsCheckboxField | RadioField>(
				field,
				['termsAndConditionsCheckbox', 'radio'].includes(type),
			)
		) {
			NonEmptyValidationSchema = v.nonEmpty(field.nothingChosenErrorMessage);
		} else {
			NonEmptyValidationSchema = v.nonEmpty(field.emptyErrorMessage);
		}
	}

	const EmailValidationSchema =
		type === 'email' ? v.email(field.invalidEmailErrorMessage) : v.any();

	return v.pipe(v.string(), NonEmptyValidationSchema, EmailValidationSchema);
};

export const useValidationSchema = (field: Field) => {
	return useMemo(() => getValidationSchema(field), [field]);
};
